import { API } from '@Providers';

export default async function (outcome_date: string) {
  const endpoint = '/api/shelter/animal/update-animals-rto-fee-on-outcome-date';

  return API({ endpoint, method: 'put', payload: { outcome_date } });
}
